import { useSearchParams } from 'react-router-dom';
import FullScreen from '../../components/Common/FullScreen/FullScreen';
import Card from '../../components/Common/Card/Card';
import StatusText from '../../components/Common/StatusText/StatusText';
import Container from '../../components/Common/Container/Container';
import { Spacing } from '../../types/appTypes';
import ResetPasswordForm from '../../components/Login/ResetPasswordForm/ResetPasswordForm';

const ResetPasswordPage = () => {
  const [searchParams] = useSearchParams();
  const token = searchParams.get('token');
  const tokenId = searchParams.get('tokenId');
  const userId = searchParams.get('uid');

  let display: JSX.Element;
  if (token === null || token === '' || tokenId === null || tokenId === '') {
    display = (
      <Card flexDirection='column'>
        <StatusText text='Invalid or missing tokens.' error={true} />
      </Card>
    );
  } else if (userId === null || userId === '') {
    display = (
      <Card flexDirection='column'>
        <StatusText text='Invalid or missing user data.' error={true} />
      </Card>
    );
  } else {
    display = (
      <ResetPasswordForm token={token} tokenId={tokenId} userId={userId} />
    );
  }

  return (
    <FullScreen>
      <Container margin={[Spacing.Auto]}>{display}</Container>
    </FullScreen>
  );
};

export default ResetPasswordPage;
